export default {
  data() {
    return {
      visible: false,
      loading: false
    }
  },
  methods: {
    close() {
      this.visible = false
    },
    open(data = {}) {
      this.visible = true
      this.$nextTick(async () => {
        Object.assign(this.$data, data)
        if (this.handleOpen) {
          await this.handleOpen(data)
        }
        if (this.form && this.form.setFieldsValue && data.formData) {
          this.form.setFieldsValue(data.formData)
        }
      })
    },
    handleOk() {},
    handleCancel() {
      if (this.handleClose) {
        this.handleClose()
      }
      if (this.form && this.form.resetFields) {
        this.form.resetFields()
      }
      this.close()
    }
  }
}
